<div class="main_holder_mytable">
  <mat-form-field style="width:60%;">
    <mat-label>Search Client</mat-label>
    <input matInput (keyup)="applyFilter($event)" >
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table class="mytable" mat-table [dataSource]="dataSource">

      <!-- ID Column -->
      <ng-container matColumnDef="chk">
        <th mat-header-cell *matHeaderCellDef> <mat-checkbox [disabled]="dsiableAll" [(ngModel)]="mainChecked" (change)="selectAll($event)"></mat-checkbox> </th>
        <td mat-cell *matCellDef="let row;let i=index;"> <mat-checkbox [disabled]="dsiableAll || row.isJobInProgress" [(ngModel)]="row.IsSelected"></mat-checkbox> </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let row;let i=index;"> {{i+1}} </td>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Client Name </th>
        <td mat-cell *matCellDef="let row"> {{row.name}}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="outputType">
        <th mat-header-cell *matHeaderCellDef>  Output Type </th>
        <td mat-cell *matCellDef="let row;">
          <mat-form-field>
            <mat-select [disabled]="row.isJobInProgress" id="row.clientID" (selectionChange)="changeOptype($event,row.clientID)" [(ngModel)]="row.outputType">
              <mat-option *ngFor="let opt of optOptions" [value]="opt">
                {{opt}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </td>
      </ng-container>
      <ng-container matColumnDef="mode">
        <th mat-header-cell *matHeaderCellDef>  Mode </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <mat-select [disabled]="row.outputType==='GoogleDrive' || row.isJobInProgress" id="row.clientID" [(ngModel)]="row.mode">
              <mat-option *ngFor="let opt of modeOptions" [value]="opt.val">
                {{opt.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </td>
      </ng-container>
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>  Enabled </th>
        <td mat-cell *matCellDef="let row">
          <!--         <mat-form-field>  -->
          <mat-radio-group [(ngModel)]="row.googlePublishAsEnabled" aria-label="Select an option">
            <mat-radio-button value="1">Yes</mat-radio-button> &nbsp;
            <mat-radio-button value="0">No</mat-radio-button>
          </mat-radio-group>
          <!--</mat-form-field>-->
        </td>
      </ng-container>
      <ng-container matColumnDef="save">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let row"> <button [disabled]="disableSave(row) || dsiableAll || row.isJobInProgress" (click)="UpdateSettings(row)" mat-raised-button color="accent">Save Changes</button></td>
      </ng-container>
      <!-- Color Column -->


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>
    </table>

    <mat-paginator (page)="handlePage()" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  </div>
  <div class="selectAllChange" *ngIf="needDisable() ">
    <h2 style="text-align:center">Change Selected</h2>
    <div class="box_to_change">
      <mat-card style="width:50%;">
        <div>
          <mat-form-field style="width:100%;">
            <mat-label>Select Output Type</mat-label>

            <mat-select [(ngModel)]="allOpt" (selectionChange)="changeAllopt($event)">
              <mat-option *ngFor="let opt of optOptions" [value]="opt">
                {{opt}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>

          <mat-form-field style="width:100%;"  >
            <mat-label>Select Mode</mat-label>

            <mat-select [(ngModel)]="allMode" [disabled]="allOpt=='GoogleDrive'">

              <mat-option *ngFor="let opt of modeOptions" [value]="opt.val">
                {{opt.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <button mat-raised-button color="accent" [disabled]="dsiableAll" (click)="UpdateAlllsettings()">Save Changes</button>
        </div>
      </mat-card>

    </div>
  </div>
</div>
